function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import { addVoucher, removeVoucher, toggleGiftWrap, changeCountry, changeShippingMethod, changePaymentMethod, initiateKlarna, updateKlarna, initiateIngrid, updateIngrid, updateAdyen, changeAddressInput, changeUseShippingInput, changeGiftWrapInput, purchase, toggleLogin, entryAccount, forceTermsAndCondition, getPaymentInfoItem, updateGlobalECountry } from "../shop/connect";
import { paymentMethodsMap } from "../config";
import { getCookie, setCookie } from "../util/dom";
import { strToBool } from "../util/string";
import abandonedCart from "../components/abandoned-cart";
var klarnaInitiated = false;
var checkout = {
  init: function init() {
    var _this = this;
    abandonedCart();
    this.updateSelectionError();
    $("#js-checkoutPageDelivery,#js-checkoutPageAddressForm").on("click", ".dropdown-item", function (e) {
      e.preventDefault();
      var id = $(e.currentTarget).parent().data("name");
      var value = $(e.currentTarget).data('value');
      var parent = $(e.currentTarget).parents('.js-state');
      var group = 'address';
      if (parent.length && parent.data("group")) {
        group = parent.data("group");
      }
      $('#checkout-adyen').hide();
      changeAddressInput(group, id, value);
      if (id === 'country') {
        var currentHeight = $("#js-shipwalletSnippet").height();
        $("#js-shipwalletSnippet").html('').height(currentHeight);
        changeCountry(value).then(function (changeCountryAction) {
          initiateIngrid();
          _this.updateSelectionError();
          if (changeCountryAction.selection.centraCheckoutScript) {
            var checkoutScriptContainer = document.getElementById('js-checkoutScript');
            if (checkoutScriptContainer) {
              checkoutScriptContainer.innerHTML = '';
              _this.appendCheckoutScript(checkoutScriptContainer, changeCountryAction.selection.centraCheckoutScript);
            }
          }
          var paymentMethods = changeCountryAction.paymentMethods || {};
          updateAdyen();
          updateGlobalECountry();
          if (!paymentMethods) return;
          var hasKlarnaCheckout = paymentMethods.filter(function (method) {
            if (Array.isArray(paymentMethodsMap.klarnaCheckout) && paymentMethodsMap.klarnaCheckout.indexOf(method.paymentMethod) !== -1) {
              return true;
            }
            return false;
          });
          if (hasKlarnaCheckout.length === 0) return;
          if (klarnaInitiated) {
            // window.location = window.location.href;
            updateKlarna();
          } else {
            initiateKlarna().then(function (initiateKlarnaAction) {
              if (initiateKlarnaAction.data && initiateKlarnaAction.data.formHtml) {
                klarnaInitiated = true;
                $("#js-klarnaCheckout").html(initiateKlarnaAction.data.formHtml);
              }
              if (initiateKlarnaAction.error && initiateKlarnaAction.error === "SELECTION_ERROR_STOCK") {
                $("#js-checkoutErrors").find(".js-stockError").show();
                setTimeout(function () {
                  $("#js-checkoutErrors").find(".js-stockError").fadeOut();
                }, 1e4);
              }
            });
          }
        });
      } else if (getPaymentInfoItem('useShippingAddress') === false && group === 'shippingAddress') {
        changeAddressInput('address', id, value);
      }
    });
    $("#js-checkoutPageDelivery").on("click", ".js-toggleLogin", function (e) {
      e.preventDefault();
      toggleLogin();
    });
    $("#js-checkoutLoginForm").on("submit", function (e) {
      e.preventDefault();
      entryAccount("login");
    });
    $("#js-shippingChoices").on("change", "input", function (e) {
      var $this = $(e.currentTarget);
      changeShippingMethod($this.val()).then(function () {
        updateKlarna();
        updateAdyen();
        _this.updateSelectionError();
      });
    });
    $("#js-paymentChoices").on("change", "input", function (e) {
      var $this = $(e.currentTarget);
      changePaymentMethod($this.val()).then(function () {
        $('#checkout-adyen').hide();
        $("#js-purchase").parent().toggle(paymentMethodsMap.klarnaCheckout.indexOf($this.val()) === -1);
        _this.updateSelectionError();
        if (paymentMethodsMap.klarnaCheckout.indexOf($this.val()) !== -1 && !klarnaInitiated) {
          initiateKlarna().then(function (action) {
            if (action.data && action.data.formHtml) {
              klarnaInitiated = true;
              $("#js-klarnaCheckout").html(action.data.formHtml);
            }
            if (action.error && action.error === "SELECTION_ERROR_STOCK") {
              $("#js-checkoutErrors").find(".js-stockError").show();
              setTimeout(function () {
                $("#js-checkoutErrors").find(".js-stockError").fadeOut();
              }, 1e4);
            }
          });
        }
      });
    });
    $("#js-checkoutPageMessage").on("click", ".js-toggleMessage", function (e) {
      e.preventDefault();
      $(e.currentTarget).parent().toggleClass("is-toggled");
    });
    $("#js-checkoutPageAddressForm,#js-checkoutPageShippingAddressForm,#js-checkoutPageAccountForm,#js-checkoutLoginForm,#js-checkoutRegisterForm").on("keydown change blur", "input", function (e) {
      var id = $(e.currentTarget).attr("name");
      var value = $(e.currentTarget).val();
      var group = $(e.currentTarget).data("group") ? $(e.currentTarget).data("group") : "address";
      $(e.currentTarget).parent().removeClass("is-invalid");
      if (e.type !== "keydown") {
        changeAddressInput(group, id, value);
        if (getPaymentInfoItem('useShippingAddress') === false && group === 'shippingAddress') {
          changeAddressInput('address', id, value);
        }
      }
      if (e.type === "focusout") {
        updateAdyen();
      }
    });
    $("#js-useShippingAddress").on("change", function (e) {
      $("#js-checkoutPageAddressForm").toggle(!$(e.currentTarget).prop('checked'));
      changeUseShippingInput();
      $("#js-checkoutPageAddressForm input").each(function (pos, el) {
        var value = $(el).val();
        var id = $(el).attr("name");
        var group = $(el).data("group");
        if (!value) changeAddressInput(group, id, value);
      });
      if (e.type === "focusout") {
        updateAdyen();
      }
    });
    $(".js-checkboxInputs,#js-checkboxInputs-terms, #checkout-duties").on("change", "input", function (e) {
      var id = $(e.currentTarget).attr("name");
      var group = id === "newsletter" ? "address" : false;
      var value = $(e.currentTarget).prop("checked");
      if (id === "createAccount" && !value) {
        $('#js-checkoutRegisterForm').find('.is-invalid').removeClass('is-invalid');
      }
      changeAddressInput(group, id, value);
      if (id === "newsletter") {
        updateKlarna();
        updateAdyen();
      }
    });
    $("#js-checkoutPageMessage").on("keydown blur", "textarea", function (e) {
      var id = $(e.currentTarget).attr("name");
      var value = $(e.currentTarget).val();
      changeAddressInput(false, id, value);
      if (e.type === "focusout") {
        updateKlarna();
        updateAdyen();
      }
    });
    $("#js-toggleGiftWrap").on("click", function (e) {
      e.preventDefault();
      toggleGiftWrap();
    });
    $("#js-giftWrap").on("keydown blur", "textarea", function (e) {
      var value = $(e.currentTarget).val();
      changeGiftWrapInput(value);
      if (e.type === "focusout") {
        updateKlarna();
        updateAdyen();
      }
    });
    $("#js-purchase").on("click", function (e) {
      e.preventDefault();
      _this.updateSelectionError();
      purchase(true);
    });
    $(".js-change-country, .js-change-state").on("click", function (e) {
      e.preventDefault();
      var scrollToElement = $($(e.currentTarget).attr("href"));
      if (scrollToElement.length === 0) return;
      $('html,body').stop(true).animate({
        scrollTop: scrollToElement.first().offset().top - window.innerHeight / 2
      }, 400);
    });
    $(window).on("store.firstRender", function (e, renderedStore) {
      console.log('store.firstRender');
      if ($(".js-checkoutPageVoucher").find(".js-addedVouchers").children().length > 0) {
        $(".js-checkoutPageVoucher").addClass("is-toggled");
      }
      forceTermsAndCondition(true);

      // Initiate ingrid
      initiateIngrid();
      if (renderedStore.paymentReturn.centraCheckoutScript) {
        var addCheckoutScriptContainer = document.createElement("div");
        addCheckoutScriptContainer.id = 'js-checkoutScript';
        var container = _this.appendCheckoutScript(addCheckoutScriptContainer, renderedStore.paymentReturn.centraCheckoutScript);
        document.body.appendChild(container);
      }
      initiateKlarna().then(function (action) {
        if (action.data && action.data.formHtml) {
          klarnaInitiated = true;
          $("#js-klarnaCheckout").html(action.data.formHtml);
        }
        if (action.error && action.error === "SELECTION_ERROR_STOCK") {
          $("#js-checkoutErrors").find(".js-stockError").show();
          setTimeout(function () {
            $("#js-checkoutErrors").find(".js-stockError").fadeOut();
          }, 1e4);
        }
      }).catch(function (err) {
        return console.log("KCO not initiated");
      });

      // Catch Ingrid checkout updates
      document.addEventListener("centra_checkout_callback", function (centraData) {
        console.log("centra_checkout_callback");
        centraData.detail.action = "process_checkout_update";
        updateIngrid(centraData.detail);
        updateAdyen();
        // updateKlarna();
      });
    });
  },
  updateSelectionError: function updateSelectionError() {
    var renderSelectionFailed = getCookie('renderSelectionError');
    var selectionErrorEl = $('#js-selectionSelectionFailedError');
    if (renderSelectionFailed != null && strToBool(renderSelectionFailed)) {
      selectionErrorEl.show();
      setCookie('renderSelectionError', false);
    } else {
      selectionErrorEl.hide();
    }
  },
  appendCheckoutScript: function appendCheckoutScript(container, centraCheckoutScript) {
    var addCheckoutScript = document.createElement("script");
    addCheckoutScript.text = centraCheckoutScript;
    container.appendChild(addCheckoutScript);
    return container;
  },
  scrolledScreen: function scrolledScreen() {
    var numberPositions = [];
    var whichNumber = 0;
    var headerPosition = $(".checkoutPage-header").innerHeight();
    var hasScrolledPast = false;
    var checkoutScroll = function checkoutScroll() {
      var scrollTop = $(window).scrollTop();
      var windowHeight = window.innerHeight;
      var differences = numberPositions.map(function (position) {
        return Math.abs(position - (scrollTop + windowHeight / 2));
      });
      var closest = Math.min.apply(Math, _toConsumableArray(differences));
      if (differences.indexOf(closest) !== whichNumber) {
        whichNumber = differences.indexOf(closest);
        $('.js-section').removeClass('is-active');
        $('.js-section:visible').eq(whichNumber).addClass('is-active');
      }
      if (!hasScrolledPast && scrollTop > headerPosition) {
        // Show sticky bar
        $("html").addClass("is-passedCheckoutHeader");
        hasScrolledPast = true;
      } else if (hasScrolledPast && scrollTop <= headerPosition) {
        $("html").removeClass("is-passedCheckoutHeader");
        hasScrolledPast = false;
      }
    };
    var updatePositions = function updatePositions() {
      numberPositions = [];
      $('.js-number:visible').each(function (i, el) {
        numberPositions[i] = $(el).offset().top;
      });
      headerPosition = $(".checkoutPage-header").innerHeight();
      checkoutScroll();
    };
    $(window).on("store.updated", updatePositions);
    $(window).on("scroll", function () {
      window.requestAnimationFrame(function () {
        checkoutScroll();
      });
    }).on("resize", updatePositions);
  },
  finalize: function finalize() {}
};
export default checkout;


// WEBPACK FOOTER //
// ./scripts/routes/checkout.js